export const FLOOR_CREATE_REQUEST = 'FLOOR_CREATE_REQUEST'
export const FLOOR_CREATE_SUCCESS = 'FLOOR_CREATE_SUCCESS'
export const FLOOR_CREATE_FAIL = 'FLOOR_CREATE_FAIL'
export const FLOOR_CREATE_RESET = 'FLOOR_CREATE_RESET'


export const LIST_FLOOR_REQUEST = 'LIST_FLOOR_REQUEST'
export const LIST_FLOOR_SUCCESS = 'LIST_FLOOR_SUCCESS'
export const LIST_FLOOR_FAIL = 'LIST_FLOOR_FAIL'
export const LIST_FLOOR_RESET = 'LIST_FLOOR_RESET'


export const FLOOR_DELETE_REQUEST = 'FLOOR_DELETE_REQUEST'
export const FLOOR_DELETE_SUCCESS = 'FLOOR_DELETE_SUCCESS'
export const FLOOR_DELETE_FAIL = 'FLOOR_DELETE_FAIL'

export const FLOOR_UPDATE_REQUEST = 'FLOOR_UPDATE_REQUEST'
export const FLOOR_UPDATE_SUCCESS = 'FLOOR_UPDATE_SUCCESS'
export const FLOOR_UPDATE_FAIL = 'FLOOR_UPDATE_FAIL'
export const FLOOR_UPDATE_RESET = 'FLOOR_UPDATE_RESET'


export const FLOOR_DETAILS_REQUEST = 'FLOOR_DETAILS_REQUEST'
export const FLOOR_DETAILS_SUCCESS = 'FLOOR_DETAILS_SUCCESS'
export const FLOOR_DETAILS_FAIL = 'FLOOR_DETAILS_FAIL'